<template>
    <loading-indicator v-if="loading"/>
    <div v-else class="xl-padding">
        <div class="row">
            <div class="col-md-4">
                <person-box-employee :id="employeeId">
                    Erstellt am {{dateHelper('d.m.Y H:i', created)}}
                </person-box-employee>
                <div class="spacer spacer-15 visible-sm-downward">&nbsp;</div>
            </div>

            <div class="col-md-4">
                <strong>Zeitraum</strong>
                <br>
                <template v-if="days >= 1">
                    <template v-if="ranges && ranges.length > 1">
                        <div v-for="range in ranges">
                            {{ dateHelper('D, d.m.Y', range.start) }} bis
                            {{ dateHelper('D, d.m.Y', range.end) }}
                            ({{ range.days + ' Tag' + (range.days !== 1 ? 'e' : '') }})
                        </div>
                    </template>
                    <template v-else>
                        {{ dateHelper('D, d.m.Y', start) }} bis
                        {{ dateHelper('D, d.m.Y', end) }}
                        <template v-if="days">({{ days + ' Tag' + (days !== 1 ? 'e' : '') }})</template>
                    </template>
                </template>
                <template v-else>
                    {{ dateHelper('D, d.m.Y H:i', start) }} bis
                    {{ dateHelper('H:i', end) }}
                </template>
                <div class="spacer spacer-15 visible-sm-downward">&nbsp;</div>
            </div>

            <div class="col-md-4">
                <strong>Resturlaub</strong><br>
                {{remaining}} Tag{{remaining === '1' ? '' : 'e'}}
            </div>
        </div>

        <div class="form-spacer">&nbsp;</div>

        <div class="row">
            <div class="col-md-4">
                <strong>Status</strong><br>
                <div v-if="stateRequested === state">
                    <i class="material-icons md-16" aria-hidden="true" role="img">hourglass_empty</i> Urlaub beantragt
                </div>
                <div v-else-if="stateAccepted === state" class="text-success">
                    <i class="material-icons md-16" aria-hidden="true" role="img">check</i> Urlaub genehmigt
                    <span v-if="revokeState === stateRevokeRequested" class="text-warning"> (
                        <i class="material-icons md-16" aria-hidden="true" role="img">hourglass_empty</i>
                        Zurückziehung beantragt)</span>
                </div>
                <div v-else-if="stateDenied === state" class="text-danger">
                    <i class="material-icons md-16" aria-hidden="true" role="img">close</i> Antrag abgelehnt
                </div>
                <div v-else-if="stateWithdrawn === state" class="text-warning">
                    <i class="material-icons md-16" aria-hidden="true" role="img">undo</i> Urlaub zurückgezogen
                </div>
                <div class="spacer spacer-15 visible-sm-downward">&nbsp;</div>
            </div>

            <div v-if="editor" class="col-md-4">
                <strong>Bearbeiter</strong>
                <br>
                <person-box-user :id="editor" class="small">
                    Bearbeitet am {{dateHelper('d.m.Y H:i', edited)}}
                </person-box-user>
            </div>
        </div>

        <div class="form-spacer">&nbsp;</div>

        <div>
            <strong>Begründung des Antrags</strong>
            <br>
            <div>{{requestReason || 'Keine Begründung angegeben.'}}</div>
        </div>

        <div v-if="blocked && blocked.length" class="default-margin-top">
            <div class="info">
                <i class="material-icons md-light" aria-hidden="true" role="img">info</i>
                <div>
                    Seit dem Antrag wurden neue gesperrte Tage erstellt:

                    <ul>
                        <li v-for="message in blocked" v-text="message"></li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="form-spacer">&nbsp;</div>

        <div v-if="stateDenied === state">
            <strong>Ablehnungsgrund</strong>
            <br>
            <div v-html="comment"/>
        </div>

        <template v-if="0 !== regulations.length && state !== stateAccepted">
            <hr>
            <div class="row">
                <div class="col-md-9">
                    <div class="row">
                        <div v-for="(regulation, i) of regulations" :class="['col-lg-12', {'spacer-15': 0 !== i}]">
                            <absence-calendar :vacation-request-id="id" :regulation-id="regulation" :show-regulation-title="true" :display-navigation="false" :show-planning="true" :show-explanation="false" :year="dateHelper('Y', start)" tag="div"/>
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <portuna-box class="no-padding no-margin">
                        <table class="portuna-table portuna-table-bordered">
                            <colgroup>
                                <col style="width: 25%;"/>
                                <col style="width: 75%;"/>
                            </colgroup>
                            <tbody>
                            <tr>
                                <td class="text-center"><i class="material-icons" aria-hidden="true" role="img">flight_takeoff</i></td>
                                <td class="text-center">Urlaub</td>
                            </tr>
                            <tr>
                                <td class="text-center"><i class="material-icons" aria-hidden="true" role="img">block</i></td>
                                <td class="text-center">Sonstiges</td>
                            </tr>
                            <tr>
                                <td class="text-center"><i class="material-icons" aria-hidden="true" role="img">school</i></td>
                                <td class="text-center">Berufsschule</td>
                            </tr>
                            <tr>
                                <td class="text-center"><i class="material-icons" aria-hidden="true" role="img">public</i></td>
                                <td class="text-center">Feiertag</td>
                            </tr>
                            <tr>
                                <td class="text-center"><i class="material-icons" aria-hidden="true" role="img">local_hospital</i></td>
                                <td class="text-center">Krank</td>
                            </tr>
                            <tr>
                                <td class="text-center"><i class="material-icons" aria-hidden="true" role="img">clear</i></td>
                                <td class="text-center">Nicht eingestellt</td>
                            </tr>
                            <tr>
                                <td class="text-center"><i class="material-icons" aria-hidden="true" role="img">access_time</i></td>
                                <td class="text-center">Stundenabbau</td>
                            </tr>
                            <tr>
                                <td class="text-center"><i class="material-icons" aria-hidden="true" role="img">access_time</i></td>
                                <td class="text-center">Zeitplanung (Abwesend)</td>
                            </tr>
                            </tbody>
                        </table>
                    </portuna-box>
                </div>
            </div>
        </template>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator';
    import FormRow from '../../../components/form/FormRow.vue';
    import LoadingIndicator from '../../../components/LoadingIndicator.vue';
    import PersonBoxEmployee from '../../../components/PersonBoxEmployee.vue';
    import PersonBoxUser from '../../../components/PersonBoxUser.vue';
    import PortunaBox from '../../../components/PortunaBox.vue';
    import {
        VACATION_ENTRY_REVOKE_STATE_WAIT,
        VACATION_ENTRY_STATE_ACCEPTED,
        VACATION_ENTRY_STATE_DENIED,
        VACATION_ENTRY_STATE_REQUESTED,
        VACATION_ENTRY_STATE_WITHDRAWN,
    } from '../../../library/modules/vacation/entry';
    import {popupDefaultCloseButton} from '../../../library/popup';
    import {errorHandler} from '../../../utils/portuna';
    import dateHelper from '../../../utils/portuna/dateHelper';
    import AbsenceCalendar from '../../absences/AbsenceCalendar.vue';

    @Component({
        name: 'VacationEntryViewPopup',
        components: {
            PersonBoxUser,
            PersonBoxEmployee,
            PortunaBox,
            AbsenceCalendar,
            FormRow,
            LoadingIndicator
        },
        methods: {
            dateHelper
        }
    })
    export default class VacationEntryViewPopup extends Vue
    {
        @Prop({
            type: Number,
            required: true,
        }) id: number;

        stateRequested = VACATION_ENTRY_STATE_REQUESTED;

        stateAccepted = VACATION_ENTRY_STATE_ACCEPTED;

        stateDenied = VACATION_ENTRY_STATE_DENIED;

        stateWithdrawn = VACATION_ENTRY_STATE_WITHDRAWN;

        stateRevokeRequested = VACATION_ENTRY_REVOKE_STATE_WAIT;

        get buttons(): PopupButton[]
        {
            return [
                popupDefaultCloseButton,
            ];
        }

        employeeId: number = 0;

        state: string = '';
        revokeState: string = '';
        comment: string = '';
        requestReason: string = '';

        createdAt: string = '';
        editor: number =0;
        edited: string = '';

        start: string = '';

        end: string = '';

        ranges: { start: string, end: string, days: number }[];

        days: number = 0;

        remaining: string = '';

        regulations: number[] = [];

        loading: boolean = true;

        blocked: string[];

        created()
        {
            this.emitter.emit('setButtons', this.buttons);
            this.fetch();
        }

        fetch()
        {
            this.axios.get(`/employee/absences-statistic/fetch-calendar-list/vr_id/${this.id}`)
            .then(({data: {data: r}}) =>
            {
                this.employeeId  = r.employee_id;
                this.state       = r.state;
                this.revokeState = r.revoke_state;
                this.comment = r.comment;
                this.requestReason = r.request_reason;
                this.createdAt   = r.created;
                this.editor      = r.editor;
                this.edited      = r.edited;
                this.start       = r.start;
                this.end         = r.end;
                this.ranges      = r.ranges;
                this.days        = r.days;
                this.remaining   = r.remaining;
                this.regulations = r.regulations;
                this.blocked     = r.blocked;
                this.loading     = false;
            })
            .catch((err) =>
            {
                errorHandler(err);
                this.emitter.emit('close');
            });
        }
    }
</script>